var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3111 6H6.0889C4.49324 6 3.20001 7.27902 3.20001 8.85714V23.1429C3.20001 24.721 4.49324 26 6.0889 26H26.3111C27.9068 26 29.2 24.721 29.2 23.1429V8.85714C29.2 7.27902 27.9045 6 26.3111 6ZM5.37255 8.85714C5.37255 8.46259 5.69592 8.14286 6.09477 8.14286H26.308C26.7068 8.14286 27.0302 8.46259 27.0302 8.85714V10.2857H5.37255V8.85714ZM27.0288 23.1429C27.0288 23.5373 26.7055 23.8571 26.3066 23.8571H6.09477C5.69592 23.8571 5.37255 23.5373 5.37255 23.1429L5.36668 14.5714H27.0333L27.0288 23.1429ZM8.61668 21.7143H10.7833C11.3814 21.7143 11.8261 21.2344 11.8261 20.6429C11.8261 20.0513 11.3837 19.5714 10.7833 19.5714H8.61668C8.02085 19.5714 7.53335 20.0536 7.53335 20.6429C7.53335 21.2321 8.02085 21.7143 8.61668 21.7143ZM14.3945 21.7143H19.45C20.0481 21.7143 20.5333 21.2344 20.5333 20.6429C20.5333 20.0509 20.0481 19.5714 19.45 19.5714H14.3945C13.7941 19.5714 13.3111 20.0491 13.3111 20.6429C13.3111 21.2366 13.7941 21.7143 14.3945 21.7143Z",
    fill: "#3FAE7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.a120c815d1df74ca137f256320123f07.svg";
export { ForwardRef as ReactComponent };